export const FRONTEND_I18N_LOCALES = ['en', 'pt_BR'];

export const resolveFrontendLocale = (locale, fallback = 'en') => {
  if (!locale) return fallback;
  if (FRONTEND_I18N_LOCALES.includes(locale)) return locale;
  if (locale === 'pt' || String(locale).startsWith('pt')) return 'pt_BR';
  return fallback;
};
